import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import {TokenService} from "./services/token.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    constructor(private _router: Router, public tokenService: TokenService) {}

    public main;

    ngOnInit() {
        //this._router.navigateByUrl("/monitor/listar/erros")
    }

    getState(outlet) {
        return outlet.activatedRouteData.state
    }
}
